import { QueryState } from 'common/enums';
import { Nullable } from 'utils/Nullable';
import { IIncident } from 'interfaces/incident.interface';

export interface IArchivedState {
  state: QueryState;
  incidentList: Nullable<IIncident[]>;
  page: number;
  lastPage: number;
  pageLimit: number;
  initialPageTotal: number;
  pageTotal: number;
  error: Nullable<string>;
}

export const ArchivedEmptyState: IArchivedState = {
  state: QueryState.UNDEFINED,
  incidentList: [],
  page: 1,
  lastPage: 0,
  pageLimit: parseInt(process.env.REACT_APP_LIST_LIMIT || '10'),
  initialPageTotal: 0,
  pageTotal: 0,
  error: null,
};
